import { ModelTransformer } from '../common/common.model';

export interface ExtTeamCoaching {
    userId: number;
    usersWithGoals: number;
    usersMeetingGoals: number;
    usersNotMeetingGoals: number;
    usersWithoutGoals: number;
    oldGoals: number;
}

export enum TeamCoachingPerformerType {
    WITH_GOALS,
    NOT_MEETING_GOALS,
    MEETING_GOALS,
    OLD_GOALS,
    WITHOUT_GOALS,
}

export interface TeamCoachingItem {
    performerType: TeamCoachingPerformerType;
    quantity: number;
}

export interface TeamCoaching {
    items: TeamCoachingItem[];
}

export class TeamCoachingModelTransformer
    implements ModelTransformer<TeamCoaching, ExtTeamCoaching>
{
    transform(model: ExtTeamCoaching): TeamCoaching {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/require-array-sort-compare
        const performers = <any[]>Object.values(TeamCoachingPerformerType)
            .filter((value) => typeof value === 'number')
            .sort();
        const items: TeamCoachingItem[] = [];
        performers.forEach((value) => {
            switch (value) {
                case TeamCoachingPerformerType.WITH_GOALS:
                    items.push({
                        performerType: value,
                        quantity: model.usersWithGoals,
                    });
                    break;
                case TeamCoachingPerformerType.NOT_MEETING_GOALS:
                    items.push({
                        performerType: value,
                        quantity: model.usersNotMeetingGoals,
                    });
                    break;
                case TeamCoachingPerformerType.MEETING_GOALS:
                    items.push({
                        performerType: value,
                        quantity: model.usersMeetingGoals,
                    });
                    break;
                case TeamCoachingPerformerType.OLD_GOALS:
                    items.push({
                        performerType: value,
                        quantity: model.oldGoals,
                    });
                    break;
                case TeamCoachingPerformerType.WITHOUT_GOALS:
                    items.push({
                        performerType: value,
                        quantity: model.usersWithoutGoals,
                    });
                    break;
            }
        });
        return {
            items,
        };
    }
}

export function validateTeamCoaching(model: TeamCoaching): void {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    const valid =
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        model != null && model.items != null && model.items.length !== 0;
    if (!valid) {
        throw new Error('TeamCoaching not valid');
    }
}
